import { render, staticRenderFns } from "./lableRecycleBin.vue?vue&type=template&id=cc61ab4c&scoped=true"
import script from "./lableRecycleBin.vue?vue&type=script&lang=js"
export * from "./lableRecycleBin.vue?vue&type=script&lang=js"
import style0 from "./lableRecycleBin.vue?vue&type=style&index=0&id=cc61ab4c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc61ab4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc61ab4c')) {
      api.createRecord('cc61ab4c', component.options)
    } else {
      api.reload('cc61ab4c', component.options)
    }
    module.hot.accept("./lableRecycleBin.vue?vue&type=template&id=cc61ab4c&scoped=true", function () {
      api.rerender('cc61ab4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LabelGroup/lableRecycleBin.vue"
export default component.exports